import type { Sensor } from 'services/sensor/SensorsProvider/types';

const filterSensorsByDebugFlag = (sensors: Sensor[]) => {
  let debugProfileTypes: string[] = [];
  try {
    debugProfileTypes = JSON.parse(sessionStorage.getItem('mm_debugProfileTypes') || '[]') as string[];
  } catch {
    debugProfileTypes = [];
  }

  if (!debugProfileTypes?.length) {
    return sensors;
  }

  return sensors.filter(
    (sensor) => sensor.Profile?.profileType && debugProfileTypes.includes(sensor.Profile?.profileType),
  );
};

export default filterSensorsByDebugFlag;
